import { render, staticRenderFns } from "./LockedAccount.vue?vue&type=template&id=2887b422&scoped=true&lang=html&"
import script from "./LockedAccount.vue?vue&type=script&lang=js&"
export * from "./LockedAccount.vue?vue&type=script&lang=js&"
import style0 from "./LockedAccount.vue?vue&type=style&index=0&id=2887b422&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887b422",
  null
  
)

export default component.exports